<template>
  <div class="routerInfo">

    <div class="container-fluid container-panel container-mainblock">
      <div class="container">
        <div class="container-head">
          <div class="mainblock-left">
            <font-awesome-icon class="mainblock-icon" style="color: red" icon="cubes"></font-awesome-icon>
            <a  class="mainblock-label">视频列表</a>
          </div>
        </div>
        <div class="container-body">
          <el-row>
            <el-col :span="4">
              <el-menu @select="moduleClick">
                <el-submenu v-for="nm in videoModule" :key="nm.value" :index="nm.value">
                  <template slot="title">
                    <span>{{nm.label}}</span>
                  </template>
                  <el-menu-item-group>
                    <el-menu-item v-for="cnm in nm.children" :key="cnm.value" :index="cnm.value">{{cnm.label}}</el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
              </el-menu>
            </el-col>
            <el-col :span="16">
              <div><span style="color: blue;font-size: 20px;">{{currentModuleName}}</span></div>
              <ul class="panel-course" >
                <li v-for="topic in topicList">
                  <a target="_blank" class="card-course" @click="toVideoDetail(topic.dataId)">
                    <div class="card-course-top">
                      <img :src="url+topic.coverUrl"/>
                    </div>
                    <div class="card-course-name">{{topic.title}}</div>
                  </a>
                </li>
              </ul>
              <el-button type="primary" v-show="pagePreShow" v-on:click="prePage()">上一页</el-button>
              <el-button type="primary" v-show="pageNextShow" v-on:click="nextPage()">下一页</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>


  </div>
</template>

<style rel='stylesheet/less' lang='less' scoped>
@import "../../assets/less/variables.less";
@import "../../assets/less/mySearch.less";
@import "../../assets/less/style.less";
</style>

<script type="text/ecmascript-6">
import viewFunction from "../../assets/js/viewFunction";
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'Training',
  inject:['check','changeActiveIndex'],
  data(){
    return {
      topicList: [],
      //url:'http://121.89.210.255:8080/jinneng/'
      //url:'https://www.jnjtzxpx.com/jinneng/',
      url:'https://www.jnjtzxpx.com/jinnengApi/',
      currentModule: '',
      currentModuleName: '',
      pagePreShow: false,
      pageNextShow: false,
      pageNum:1,
      pageSize: 9,
      videoModule:[
        {
          value: "1",
          label: '专业教学',
          children: [
            {value: "3", label: '岗位技能'},
            {value: "4", label: '管理改善'},
            {value: "5", label: '精品课程'},
            {value: "16", label: '专题培训'}]
        },
        {
          value: "17",
          label: '安全培训',
          children: [{value: "18", label: '安全文件'},
            {value: "19", label: '安全知识'},
            {value: "20", label: '安全视频'},
            {value: "21", label: '安全专题'}]
        },
        {
          value:"6",
          label: '在线视听',
          children: [
            {value: "12", label: '知识课堂'}]
        }
      ]
    }
  },
  mounted() {
    this.findAllData()
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    ...mapGetters({
      navigationList: 'navs'
    })
  },
  methods:{
    moduleClick(index){
      this.pageNum = 1
      this.getLabel(index)
      this.currentModule = index
      this.findAllData(index)
    },
    getLabel(value){
      // 遍历查找
      for (const item of this.videoModule) {
        if (item.children) {
          for (const child of item.children) {
            if (child.value === value) {
              this.currentModuleName = item.label + ">" + child.label
              return;
            }
          }
        }
      }
    },
    findAllData(){
      var params = {
        module:this.currentModule,
        pageNum:this.pageNum,
        pageSize: this.pageSize
      }
      let url = '/api/newsView/findVideoList'
      let that = this
      this.axios.post(url,params).then(res =>viewFunction.handlerRes(that,res,function (){
        that.topicList = res.data
        if(that.pageNum === 1){
          that.pagePreShow = res.data.length === that.pageSize
        }else{
          that.pagePreShow = res.data.length > 0
        }
        that.pageNextShow = res.data.length === that.pageSize
      }))
    },
    toVideoDetail(newsId){

      let user = this.user
      if (user== null){
        this.check()
      }else {
        this.$router.push({
          path:'/VideoDetail',
          query:{
            videoNewsId:newsId
          }
        })
      }
    },
    prePage(){
      if(this.pageNum > 1){
        this.pageNum = this.pageNum - 1
        this.findAllData()
      }else{
        this.$message({
          message: '已经是第一页',
          type: 'warning'
        });
      }
    },
    nextPage(){
      this.pageNum = this.pageNum + 1
      this.findAllData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/learn/VideoList.vue